export const User = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="9" r="6" stroke="currentColor" stroke-width="2"/>
<path d="M7 30V25C7 21.6863 9.68629 19 13 19H19C22.3137 19 25 21.6863 25 25V30" stroke="currentColor" stroke-width="2"/>
</svg>`;
